import * as yup from 'yup'
import { BuildABoxDto, CompanyDto, VehicleDto } from 'dtos'

export class BuildABoxBundleDto {
  buildABoxBundleGuid?: string = undefined
  ownerCompany?: CompanyDto = undefined
  vehiclesInBundle?: number = undefined
  isLocked: boolean = false
  buildABoxBundleLockedDateTime?: string = undefined
  vehicles?: VehicleDto[] = undefined
  ohioTitlesCoverLetterFileName?: string = undefined
  buildABox?: BuildABoxDto = undefined
}

export const buildABoxBundleValidationSchema = yup.object<BuildABoxBundleDto>({
  ownerCompany: yup.object().required('Owner is required.')
})
